import ApiService from '@/shared/api'
import TypeRoles from '@/shared/api/Main/dataSource/api/pm/authorization/models/enums/TypeRoles'

import {
  CurrentUserModel,
  UserRoleEnum,
  CurrentUser,
  PersonalizationModel,
  ThemeEnum,
  SetSize,
  SetTheme,
} from 'tir-pm-user-core'

export class CurrentUserService {
  private static readonly api = new ApiService()

  private static mapRole = (role: TypeRoles) => {
    return {
      [TypeRoles.Employee]: UserRoleEnum.Employee,
      [TypeRoles.Owner]: UserRoleEnum.Owner,
      [TypeRoles.NamespaceAdmin]: UserRoleEnum.NamespaceAdmin,
      [TypeRoles.ProjectAdmin]: UserRoleEnum.ProjectAdmin,
    }[role]
  }

  /**Получить текущего пользвателя */
  private static async getCurrentUser(): Promise<CurrentUserModel | undefined> {
    return new Promise<CurrentUserModel | undefined>(async (resolve) => {
      await this.api.Main.UsersService.getCurrentUserAsync()
        .then(async (resp) => {
          const user = new CurrentUserModel({
            Id: resp.Id,
            Email: resp.Email,
            FirstName: resp.FirstName,
            LastName: resp.LastName,
            MiddleName: resp.MiddleName,
            AvatarColor: resp.AvatarColor,
            Foto: resp.Foto,
            Roles: resp.Roles.map(this.mapRole),
            Personalization: new PersonalizationModel(),
          })

          const settingsResponse =
            await this.api.Main.PersonalSettingsService.getPersonalSettingsAsync()
          if (settingsResponse.PersonalSettings) {
            user.Personalization.FontSize =
              settingsResponse.PersonalSettings.FontSize

            const theme = settingsResponse.PersonalSettings.Theme as ThemeEnum
            const isThemeExists = Object.values(ThemeEnum).includes(theme)
            user.Personalization.Theme = isThemeExists ? theme : ThemeEnum.Light
          }

          SetSize(user.Personalization.FontSize)
          SetTheme(user.Personalization.Theme)

          return resolve(user)
        })
        .catch((e) => {
          console.error('ERROR getCurrentUser', e)
          return resolve(undefined)
        })
    })
  }

  /**Инициализация текущего пользователя */
  static async initCurrentUser() {
    const user = await this.getCurrentUser()
    if (user) CurrentUser.set(user)
  }
}
